import React from 'react'

const SettingsEmail = () => {
  return (
    <div>SettingsEmail</div>
  )
}

export default SettingsEmail